<div class='logo'>
  <img class='logo__icon-box' src='{{this.image}}' alt='{{this.name}}' />
</div>
<div class='poster-is-hidden poster'>
  <img class='poster__icon' src='{{this.image}}' alt='{{this.name}}' />
</div>
<div class='description'>
  <div class='description__first-box'>
    <div class='description__box description__box-tablet'>
      <h2 class='description__title'>INFO</h2>
      <p class='description__text'>{{this.info}}</p>
    </div>
    <div class='description__box description__box-tablet'>
      <h3 class='description__title'>WHEN</h3>
      <p class='description__text'>{{this.localDate}}</p>
      <p class='description__text'>{{this.localTime}}
        ({{this.timezone}})</p>
    </div>
  </div>
  <div class='description__second-box'>
    <div class='description__box description__box-where'>
      <h4 class='description__title'>WHERE</h4>
      <p class='description__text'>{{this.city}}, {{this.country}}</p>
      <p class='description__text'>{{placeName}}</p>
    </div>
    <div class='description__box'>
      <h5 class='description__title'>WHO</h5>
      <p class='description__text'>{{this.name}}</p>
    </div>
  </div>
</div>
<h6 class='description__title description__title-prices'>PRICES</h6>
<div class='style-prices'>
  <div>
    <div class='description__barcode-text'>
      <svg class='barcode' width='24' height='16'>
        <use href='{{this.spriteUrl}}#ticket'></use>
      </svg>
      <p class='description__text standart-prise'>Standart:
        {{this.min}}
        {{this.currency}}</p>
    </div>
    <a class='description__button' target='_blank' href='{{this.url}}'>BUY
      TICKETS</a>
  </div>
  <div>
    <div class='description__barcode-text'>
      <svg class='barcode' width='24' height='16'>
        <use href='{{this.spriteUrl}}#ticket'></use>
      </svg>
      <p class='description__text vip-prise'>VIP:
        {{this.max}}
        {{this.currency}}</p>
    </div>
    <a class='description__button' target='_blank' href='{{this.url}}'>BUY
      TICKETS</a>
  </div>
</div>
<a class='button-more-author' target='_blank' href='{{this.url}}'>MORE FROM THIS
  AUTHOR</a>